import type { McpPolicyRawToolset } from './policyTypes';

const MCP_DEFAULT_SCOPES = [
  'read:me',
  'read:account',
  'offline_access',
] as const;

/** Union of scopes for the given toolset names from a list of raw toolsets; each scope appears once. */
export function unionScopesForToolsetNames(
  toolsetNames: Iterable<string>,
  toolsets: McpPolicyRawToolset[],
): string[] {
  const byName = new Map(toolsets.map((t) => [t.name, t]));
  const out = new Set<string>();
  for (const name of toolsetNames) {
    const def = byName.get(name);
    if (!def) continue;
    for (const s of def.scopes) {
      out.add(s);
    }
  }
  return [...out].sort();
}

/**
 * Scopes for the resume form: union of scopes across the selected toolsets.
 * No JWT intersection — the API already ensures toolsets are within the authorized scope set.
 * Always includes read:me and offline_access regardless of toolset selection.
 */
export function buildMcpSelectedScopesForPost(
  selectedNames: Iterable<string>,
  toolsets: McpPolicyRawToolset[],
): string[] {
  return [
    ...new Set([
      ...MCP_DEFAULT_SCOPES,
      ...unionScopesForToolsetNames(selectedNames, toolsets),
    ]),
  ];
}
